const commonAndMisc = {
  errorMessage404: "อ๊ะ! หน้าที่คุณกำลังค้นหาไม่มีอยู่", // translated
  errorContentUnavailable:
    "อ๊ะ! เนื้อหาที่คุณกำลังมองหาไม่มีอยู่ กรุณาติดต่อเราเกี่ยวกับปัญหา", // translated
  backToHome: "กลับไปที่บ้าน", // translated
  information: "ข้อมูล", // translated
  additionalInformation: "ข้อมูลเพิ่มเติม", // translated
  destinationPlaceholder: "คุณกำลังจะไปไหน", // translated
  aboutUs: "เกี่ยวกับเรา", // translated
  pleaseWait: "โปรดรอ...", // translated
  featuredHotels: "โรงแรมเด่น", // translated
  topPackages: "แพ็คเกจยอดนิยม", // translated
  topTours: "ทัวร์ยอดนิยม", // translated
  traveller: "นักเดินทาง", // translated
  reviews: "รีวิว", // translated
  home: "หน้าหลัก", // translated
  packages: "แพ็คเกจ", // translated
  experiences: "ประสบการณ์", // translated
  close: "ปิด", // translated
  loadingMessage: "โปรดรอในขณะที่เราค้นหาราคาที่ดีที่สุดที่มีอยู่", // translated
  loadingMessageTheHotelCo: "โปรดรอในขณะที่เราค้นหาราคาที่ดีที่สุดที่มีอยู่", // translated
  loadingMessageSearchStrip:
    "กรุณารอสักครู่ในขณะที่เราค้นหาราคาที่ดีที่สุดที่มีอยู่...", // translated
  topCountriesToVisit: "ประเทศยอดนิยมที่น่าเยี่ยมชม", // translated
  profile: "ประวัติโดยย่อ", // translated
  reservations: "การจอง", // translated
  address: "ที่อยู่", // translated
  firstName: "ชื่อจริง", // translated
  lastName: "นามสกุล", // translated
  email: "อีเมล", // translated
  login: "เข้าสู่ระบบ", // translated
  logout: "ออกจากระบบ", // translated
  myProfile: "ประวัติของฉัน", // translated
  myChatRooms: "My Chats",
  chatRoomsListEmpty: "You have no chat rooms for this account.",
  chatRoomsOpen: "Open",
  chatRoomsLastActivity: "Last activity",
  chatRoomsUnread: "Unread",
  chatRoomsBadgeQuotation: "Quotation",
  chatRoomsBadgeTripOffer: "Trip offer",
  chatRoomsOpenQuotationAria: "Open quotation chat: {{name}}",
  chatRoomsOpenTripOfferAria: "Open trip offer chat: {{name}}",
  chatRoomsOpenGenericAria: "Open chat: {{name}}",
  quotationChatInvalidLink:
    "Invalid chat link. Open a chat from your profile or quotation list, or use exactly one of room_code or room_uid.",
  quotationChatNoTripDetails: "Trip details are not available for this chat.",
  chat: "Chat",
  verified: "ตรวจสอบแล้ว", // translated
  unverified: "ไม่ได้รับการยืนยัน", // translated
  selectLanguage: "เลือกภาษา", // translated
  selectCurrency: "เลือกสกุลเงิน", // translated
  upgrade: "อัพเกรด", // translated
  membership: "สมาชิกภาพ", // translated
  travelTrust: "ความน่าเชื่อถือด้านการท่องเที่ยว", // translated
  signInUp: "ลงชื่อเข้าใช้/สมัครใช้งาน", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "โรงแรมและรีสอร์ททั่วโลกในราคาขายส่งที่น่าทึ่ง", // translated
  dashboard: "แผงควบคุม", // translated
  pricing: "ราคา", // translated
  refundable: "สามารถขอคืนเงินได้", // translated
  cars: "รถ", // translated
  cruises: "เรือสำราญ", // translated
  view: "ดู", // translated
  price: "ราคา", // translated
  totalPrice: "ราคารวม", // translated
  filterRoomName: "ชื่อห้องกรอง", // translated
  get: "รับ", // translated
  guestInformationValidation: "การตรวจสอบข้อมูลแขก", // translated
  reservation: "การจอง", // translated
  checkIn: "เช็คอิน", // translated
  checkOut: "เช็คเอาท์", // translated
  paymentInitiattionErroeMessage:
    "เราไม่สามารถเริ่มกระบวนการชำระเงินของคุณได้ เราต้องขออภัยในความไม่สะดวก", // translated
  warning: "คำเตือน", // translated
  couldNotFindPriceForDateWarning:
    "เราไม่พบราคาสำหรับวันที่นี้ โปรดลองอีกครั้งสำหรับวันที่อื่น", // translated
  searchFormValidationError: "ค้นหาข้อผิดพลาดในการตรวจสอบแบบฟอร์ม", // translated
  pleaseSelectValidDateFirst: "โปรดเลือกวันที่ที่ถูกต้องก่อน", // translated
  searchError: "ค้นหาผิดพลาด", // translated
  priceSearchInitiationError:
    "เราไม่สามารถเริ่มกระบวนการค้นหาราคาได้ กรุณาลองใหม่อีกครั้งในภายหลัง. เราต้องขออภัยในความไม่สะดวก", // translated
  searchWarning: "คำเตือนการค้นหา", // translated
  couldNotFindPriceAndOrAvailability:
    "เราไม่พบราคาและ/หรือห้องว่างสำหรับคำขอของคุณ เราต้องขออภัยในความไม่สะดวก", // translated
  joinNow: "เข้าร่วมเดี๋ยวนี้", // translated
  signIn: "เข้าสู่ระบบ", // translated
  searchNow: "ค้นหาตอนนี้", // translated
  bookingFailed: "การจองล้มเหลว", // translated
  sorryForTheInconvenience: "เราต้องขออภัยในความไม่สะดวก", // translated
  paymentFailedTryAgain: "การชำระเงินล้มเหลว กรุณาลองอีกครั้ง", // translated
  quickLinks: "ลิงค์ด่วน", // translated
  tours: "ทัวร์", // translated
  termsAndConditions: "ข้อกำหนดและเงื่อนไข", // translated
  pleaseWaitWhileInitiatingPayment:
    "กรุณารอสักครู่เรากำลังค้นหาราคาที่ดีที่สุดให้อยู่…", // translated
  back: "กลับ", // translated
  nextStep: "ขั้นตอนต่อไป", // translated
  book: "หนังสือ", // translated
  checkout: "เช็คเอาท์", // translated
  specifyPickUpPoint: "ระบุจุดรับที่ต้องการ", // translated
  pickupPoint: "จุดรับของ", // translated
  optional: "ไม่จำเป็น", // translated
  remarks: "หมายเหตุ", // translated
  travellerInformation: "ข้อมูลผู้เดินทาง", // translated
  bookingRemarks: "หมายเหตุการจอง", // translated
  bookingOverview: "ภาพรวมการจอง", // translated
  paymentFailed: "การชำระเงินล้มเหลว", // translated
  paymentSuccess: "ความสำเร็จในการชำระเงิน", // translated
  at: "ที่", // translated
  person: "บุคคล", // translated
  cancellationPolicy: "นโยบายการยกเลิก", // translated
  From: "จาก", // translated
  to: "ถึง", // translated
  cancellationIs: "การยกเลิกคือ", // translated
  pickup: "หยิบ", // translated
  flights: "เที่ยวบิน", // translated
  Accommodation: "ที่พัก", // translated
  payAndBook: "ชำระเงินและจอง", // translated
  onRequest: "ตามคำขอร้อง", // translated
  weAreFindingTheBestAvailableServices:
    "เรากำลังค้นหาบริการที่ดีที่สุดที่มีอยู่", // translated
  withTheBestAvailablePrices: "ด้วยราคาที่ดีที่สุดที่มีอยู่", // translated
  inRealTime: "แบบเรียลไทม์", // translated
  seconds: "วินาที", // translated
  thisProcessCanTakeUpToOneMinute: "กระบวนการนี้อาจใช้เวลานานถึง 1 นาที", // translated
  pleaseDoNotRefreshThisPage: "กรุณาอย่ารีเฟรชหน้านี้", // translated
  wellItSeemsItCanTakeBitLonger:
    "เอ่อ... ดูเหมือนว่าจะใช้เวลานานกว่านี้สักหน่อย", // translated
  yourBrowserDoesNotSupportTheVideoTag: "เบราว์เซอร์ของคุณไม่รองรับแท็กวิดีโอ", // translated
  bookingSuccess: "การจองสำเร็จ", // translated
  bookingReference: "การอ้างอิงการจองห้องพัก", // translated
  referenceCopied: "คัดลอกข้อมูลอ้างอิงแล้ว", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "ในไม่ช้า คุณจะได้รับอีเมลที่มีข้อมูลที่จำเป็นทั้งหมดสำหรับการจองของคุณ", // translated
  viewMore: "ดูเพิ่มเติม", // translated
  readMore: "อ่านเพิ่มเติม", // translated
  customerSupport: "สนับสนุนลูกค้า", // translated
  socialMedia: "สื่อสังคม", // translated
  hours: "ชั่วโมง", // translated
  hour: "ชั่วโมง", // translated
  minutes: "นาที", // translated
  minute: "นาที", // translated
  memberId: "รหัสสมาชิก", // translated
  star: "ดาว", // translated
  stars: "ดาว", // translated
  proceed: "ดำเนินการ", // translated
  clearAllFilters: "ล้างตัวกรองทั้งหมด", // translated
  clearYourFilters: "โปรดล้างตัวเลือกตัวกรองของคุณเพื่อดูผลลัพธ์", // translated
  noOptionsForSelectedFilters: "ไม่มีตัวเลือกสำหรับจับคู่ตัวกรองของคุณ", // translated
  privacyPolicy: "นโยบายความเป็นส่วนตัว", // translated
  security: "ความปลอดภัย", // translated
  nearby: "ระยะทาง", // translated
  distanceFromSelection: "ระยะทางจากการคัดเลือก", // translated
  km: "กม", // translated
  restaurants: "ร้านอาหาร", // translated
  active: "คล่องแคล่ว", // translated
  visitSite: "เยี่ยมชมเว็บไซต์", // translated
  score: "คะแนน", // translated
  applicationAvailable: "แอปพลิเคชันที่มีอยู่", // translated
  sendUsEmail: "ส่งอีเมลถึงเรา", // translated
  sendUsYourRequest: "ส่งคำขอของคุณถึงเรา", // translated
  notAvailable: "ไม่สามารถใช้ได้", // translated
  found: "พบ", // translated
  progressAt: "ความคืบหน้า ณ", // translated
  currency: "สกุลเงิน", // translated
  sendUsRequest: "ส่งคำขอของคุณถึงเรา", // translated
  noReservationsForThisProduct: "ไม่มีการจองสินค้าชิ้นนี้", // translated
  confirmed: "ยืนยันแล้ว", // translated
  cancelled: "ยกเลิก", // translated
  pending: "รอดำเนินการ", // translated
  status: "สถานะ", // translated
  reference: "อ้างอิง", // translated
  leadGuest: "แขกนำ", // translated
  sendVoucherEmail: "ส่งอีเมล์บัตรกำนัล", // translated
  sendCancellationEmail: "ส่งอีเมลแจ้งการยกเลิก", // translated
  downloadVoucher: "ดาวน์โหลดบัตรกำนัล", // translated
  emailHasBeenSent: "ส่งอีเมลเรียบร้อยแล้ว", // translated
  emailNotSentTryAgain: "ไม่ได้ส่งอีเมล! กรุณาลองอีกครั้ง", // translated
  titleIsRequired: "ต้องระบุชื่อเรื่อง", // translated
  genderIsRequired: "ต้องระบุเพศ", // translated
  firstNameMustContainAlphabetic: "ชื่อต้องมีตัวอักษรเท่านั้น", // translated
  firstNameIsRequired: "จำเป็นต้องระบุชื่อ", // translated
  lastNameIsRequired: "ต้องระบุนามสกุล", // translated
  lastNameMustContainAlphabetic: "นามสกุลต้องมีตัวอักษรเท่านั้น", // translated
  phoneNumberInTheFormat: "หมายเลขโทรศัพท์ต้องอยู่ในรูปแบบที่ไม่มีช่องว่าง", // translated
  phoneNumberIsRequired: "ต้องระบุหมายเลขโทรศัพท์", // translated
  emailIsRequired: "จำเป็นต้องระบุอีเมล", // translated
  invalidEmail: "อีเมลไม่ถูกต้อง", // translated
  addressIsRequired: "ต้องระบุที่อยู่", // translated
  cityIsRequired: "ต้องระบุเมือง", // translated
  postalCodeIsRequired: "ต้องระบุรหัสไปรษณีย์", // translated
  countryIsRequired: "ต้องระบุประเทศ", // translated
  yourReservationIsInProgress: "การจองของคุณอยู่ระหว่างดำเนินการ", // translated
  clickHere: "คลิกที่นี่", // translated
  iHaveReadAgreeWithAbove: "ฉันได้อ่านและเห็นด้วยกับข้อความข้างต้นแล้ว", // translated
  pleaseCheckTheBox:
    "โปรดทำเครื่องหมายในช่องเพื่อระบุว่าคุณได้อ่านและเห็นด้วยกับข้อมูลที่ให้ไว้ก่อนที่จะดำเนินการขั้นตอนต่อไป", // translated
  myPoints: "คะแนนของฉัน", // translated
  noBookingsForThisProduct: "ไม่มีการจองสินค้าชิ้นนี้", // translated
  myAccount: "บัญชีของฉัน", // translated
  myBookings: "การจองของฉัน", // translated
  ourContactNumbersAre: "เบอร์ติดต่อของเราคือ", // translated
  provideImportantInfoForYourTravel:
    "แจ้งให้เราทราบข้อมูลใด ๆ ที่จะมีความสำคัญในระหว่างการเดินทางของคุณ", // translated
  contactUsToAssistWithYourBooking:
    "กรุณาติดต่อเราเพื่อช่วยเหลือในการจองของคุณ เราต้องขออภัยในความไม่สะดวก", // translated
  thursday: "วันพฤหัสบดี", // translated
  sunday: "วันอาทิตย์", // translated
  monday_to_friday: "วันจันทร์ถึงวันศุกร์", // translated
  wednesday: "วันพุธ", // translated
  tuesday: "วันอังคาร", // translated
  friday: "วันศุกร์", // translated
  operationalHours: "เวลาทำการ", // translated
  saturday: "วันเสาร์", // translated
  monday: "วันจันทร์", // translated
  closed: "ปิด", // translated
  notConfirmed: "ไม่ได้รับการัยืนยืน", // translated
  topUpPoints: "คะแนนเติมเงิน", // translated
  maintenanceTitle: "เว็บไซต์อยู่ระหว่างการบำรุงรักษา",
  maintenanceDescription:
    "เรากำลังดำเนินการบำรุงรักษาตามกำหนด โปรดกลับมาใหม่เร็ว ๆ นี้",
  maintenanceCountdownLabel: "เวลาที่เหลือโดยประมาณ",
  maintenanceLogoAlt: "โลโก้เว็บไซต์",
  maintenanceDays: "วัน",
  maintenanceHours: "ชั่วโมง",
  maintenanceMinutes: "นาที",
  maintenanceSeconds: "วินาที",
  maintenanceStatusBadge: "การบำรุงรักษาตามกำหนด",
  maintenanceRefresh: "รีเฟรชหน้า",
  maintenanceExpired:
    "การบำรุงรักษาน่าจะเสร็จสิ้นในไม่ช้า โปรดรีเฟรชหน้า",
};

export default commonAndMisc;
